import React, { Fragment, useState, useEffect } from 'react';

// Icons
import ComputerIcon from '@mui/icons-material/Computer';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import BackupTableOutlinedIcon from '@mui/icons-material/BackupTableOutlined';

// Videos
import demo_3 from '../util/videos/demo_3.mp4';
import demo_4 from '../util/videos/demo_4.mp4';
import demo_pic_1 from '../util/imgs/demo_pic_1.JPG';
import demo_5 from '../util/videos/demo_5.mp4';
  
const Features = () =>  {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    
    useEffect(() => {
        
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Check if the device is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1024;

	return (
	    <Fragment>
            {/* Section - Undetectablility */}
            <div id="proof" style={{padding: '1rem', marginLeft: 'auto', marginRight: 'auto', maxWidth: '1024px', width: '100%'}}>
                {/* Section Header */}
                <div style={{textAlign: 'center', marginBottom: '2rem'}}>
                    {/* Title - Header */}
                    <h2 style={{fontSize: `${isMobile ? '2.25rem' : '3rem'}`, fontWeight: 'bold', marginBottom: '1rem'}}>
                        Undetectable
                    </h2>
                    {/* Description - Header */}
                    <p style={{fontSize: '1.125rem', lineHeight: '1.75rem', color: 'rgb(153,153,153)', fontWeight: 500}}>
                        Here's how we ensure that Interview Cheater is undetectable.
                    </p>
                </div>

                {/* Section Divider - "Pro" */}
                <div style={{width: '100%', textAlign: 'center', maxWidth: '400px', height: '40px', marginBottom: '2rem', marginLeft: 'auto', marginRight: 'auto'}}>
                    <h3 style={{fontSize: '1.5rem', color: '#FFFF00'}}>----- Features -----</h3>
                </div>

                {/* Section - Features grid */}
                <div style={{display: 'grid', gridTemplateColumns: `${isMobile ? '1fr' : 'repeat(2,minmax(0,1fr))'}`, gap: '1.5rem'}}>
                    {/* Feature Box #1 */}
                    <a href="/help?section=undetectability" style={{textDecoration: 'none'}}>
                        <div className="yellow_border_hover" style={{border: '1px solid rgb(23,23,23)', borderRadius: '.75rem', overflow: 'hidden', cursor: 'pointer'}}>
                            {/* Header - title + description */}
                            <div style={{padding: '1.5rem', borderBottom: '1px solid rgb(23,23,23)', display: 'flex', alignItems: 'center', gap: '10px'}}>
                                <div style={{borderRadius: '50%', backgroundColor: 'rgba(255,255,0,.1)', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '3rem', height: '3rem', minWidth: '3rem', minHeight: '3rem', flexShrink: 0, marginBottom: '1rem', color: '#ffff00'}}>
                                    <ComputerIcon />
                                </div>
                                <div>
                                    <h3 style={{color: '#fff', fontWeight: 'bold', fontSize: '1.125rem', marginBottom: '10px', margin: 0}}>
                                        Invisible to Screen-Sharing Apps
                                    </h3>
                                    <p style={{color: 'rgb(156,163,175', lineHeight: '1.5rem', fontSize: '.875rem', margin: 0}}>
                                        Completely invisible during screen sharing.
                                    </p>
                                </div>
                            </div>
                            {/* Image */}
                            <div style={{padding: '1rem', background: 'rgba(0,0,0,.3)', position: 'relative', width: '100%', overflow: 'hidden', boxSizing: 'border-box'}}>
                                <video className='video feature' muted loop playsInline controlsList='nodownload' disablePictureInPicture disableRemotePlayback autoPlay>
                                    <source type='video/mp4' src={demo_3} />
                                </video>
                            </div>
                        </div>
                    </a>

                    {/* Feature Box #3 */}
                    <a href="/help?section=undetectability" style={{textDecoration: 'none'}}>
                        <div className="yellow_border_hover" style={{border: '1px solid rgb(23,23,23)', borderRadius: '.75rem', overflow: 'hidden', cursor: 'pointer'}}>
                            {/* Header - title + description */}
                            <div style={{padding: '1.5rem', borderBottom: '1px solid rgb(23,23,23)', display: 'flex', alignItems: 'center', gap: '10px'}}>
                                <div style={{borderRadius: '50%', backgroundColor: 'rgba(255,255,0,.1)', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '3rem', height: '3rem', minWidth: '3rem', minHeight: '3rem', flexShrink: 0, marginBottom: '1rem', color: '#ffff00'}}>
                                    <VisibilityOutlinedIcon />
                                </div>
                                <div>
                                    <h3 style={{color: '#fff', fontWeight: 'bold', fontSize: '1.125rem', marginBottom: '10px', margin: 0}}>
                                        Undetectable Window Movements
                                    </h3>
                                    <p style={{color: 'rgb(156,163,175', lineHeight: '1.5rem', fontSize: '.875rem', margin: 0}}>
                                        Move the window around and position it to maintain natural eye contact during interviews
                                    </p>
                                </div>
                            </div>
                            {/* Image */}
                            <div style={{padding: '1rem', background: 'rgba(0,0,0,.3)', position: 'relative', width: '100%', overflow: 'hidden', boxSizing: 'border-box'}}>
                                <video className='video feature' muted loop playsInline controlsList='nodownload' disablePictureInPicture disableRemotePlayback autoPlay>
                                    <source type='video/mp4' src={demo_4} />
                                </video>
                            </div>
                        </div>
                    </a>

                    {/* Feature Box #2 */}
                    <a href="/help?section=undetectability" style={{textDecoration: 'none'}}>
                        <div className="yellow_border_hover" style={{border: '1px solid rgb(23,23,23)', borderRadius: '.75rem', overflow: 'hidden', cursor: 'pointer'}}>
                            {/* Header - title + description */}
                            <div style={{padding: '1.5rem', borderBottom: '1px solid rgb(23,23,23)', display: 'flex', alignItems: 'center', gap: '10px'}}>
                                <div style={{borderRadius: '50%', backgroundColor: 'rgba(255,255,0,.1)', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '3rem', height: '3rem', minWidth: '3rem', minHeight: '3rem', flexShrink: 0, marginBottom: '1rem', color: '#ffff00'}}>
                                    <EmojiObjectsOutlinedIcon />
                                </div>
                                <div>
                                    <h3 style={{color: '#fff', fontWeight: 'bold', fontSize: '1.125rem', marginBottom: '10px', margin: 0}}>
                                        Solution Reasoning
                                    </h3>
                                    <p style={{color: 'rgb(156,163,175', lineHeight: '1.5rem', fontSize: '.875rem', margin: 0}}>
                                        Every solution is explained step by step, and every line of code comes with comments explaining how it works.
                                    </p>
                                </div>
                            </div>
                            {/* Image */}
                            <div style={{padding: '1rem', background: 'rgba(0,0,0,.3)', position: 'relative', width: '100%', overflow: 'hidden', boxSizing: 'border-box'}}>
                                <img style={{width: '100%', borderRadius: '5px'}} alt="Screen sharing" src={demo_pic_1} />
                            </div>
                        </div>
                    </a>

                    {/* Feature Box #4 */}
                    <a href="/help?section=undetectability" style={{textDecoration: 'none'}}>
                        <div className="yellow_border_hover" style={{border: '1px solid rgb(23,23,23)', borderRadius: '.75rem', overflow: 'hidden', cursor: 'pointer'}}>
                            {/* Header - title + description */}
                            <div style={{padding: '1.5rem', borderBottom: '1px solid rgb(23,23,23)', display: 'flex', alignItems: 'center', gap: '10px'}}>
                                <div style={{borderRadius: '50%', backgroundColor: 'rgba(255,255,0,.1)', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '3rem', height: '3rem', minWidth: '3rem', minHeight: '3rem', flexShrink: 0, marginBottom: '1rem', color: '#ffff00'}}>
                                    <BackupTableOutlinedIcon />
                                </div>
                                <div>
                                    <h3 style={{color: '#fff', fontWeight: 'bold', fontSize: '1.125rem', marginBottom: '10px', margin: 0}}>
                                        Multiple Coding Languages
                                    </h3>
                                    <p style={{color: 'rgb(156,163,175', lineHeight: '1.5rem', fontSize: '.875rem', margin: 0}}>
                                        Supports many programming languages to help you pass your coding interviews with the solutions you’re most comfortable.
                                    </p>
                                </div>
                            </div>
                            {/* Image */}
                            <div style={{padding: '1rem', background: 'rgba(0,0,0,.3)', position: 'relative', width: '100%', overflow: 'hidden', boxSizing: 'border-box'}}>
                                <video className='video feature' muted loop playsInline controlsList='nodownload' disablePictureInPicture disableRemotePlayback autoPlay>
                                    <source type='video/mp4' src={demo_5} />
                                </video>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </Fragment>
	);
}
  
export default Features;
  